// tslint:disable max-line-length
import * as React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { GreyDot, IconCircle, IconWrapper } from './styled.RegisterStepper';
import { StepTypes } from '../../app/@types/registration';

const RegisterStepper = ({ step, isDeactivatedUser }) => {
  const { t } = useTranslation();

  const steps: StepTypes[] = !isDeactivatedUser
    ? [
        {
          label: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
          key: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
          step: 1,
        },
        {
          label: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
          key: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
          step: 2,
        },
        {
          label: t('COMMON.REGISTRATION.STEPS.MYLQA_PROFILE'),
          key: t('COMMON.REGISTRATION.STEPS.MYLQA_PROFILE'),
          step: 3,
        },
      ]
    : [
        {
          label: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
          key: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
          step: 1,
        },
        {
          label: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
          key: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
          step: 2,
        },
      ];
  return (
    <>
      <div className="d-flex space-between" style={{ marginBottom: '2px' }}>
        {!isDeactivatedUser
          ? [
              {
                label: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
                key: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
                step: 1,
              },
              {
                label: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
                key: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
                step: 2,
              },
              {
                label: t('COMMON.REGISTRATION.STEPS.MYLQA_PROFILE'),
                key: t('COMMON.REGISTRATION.STEPS.MYLQA_PROFILE'),
                step: 3,
              },
            ].map((item: any, index) => {
              return (
                <div
                  className={
                    item.step <= step ? 'itemWrapper' : 'itemWrapper active'
                  }
                  key={index}
                >
                  {item.label}
                </div>
              );
            })
          : [
              {
                label: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
                key: t('COMMON.REGISTRATION.STEPS.HOTEL_ACTIVATION'),
                step: 1,
              },
              {
                label: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
                key: t('COMMON.REGISTRATION.STEPS.SET_PASSWORD'),
                step: 2,
              },
            ].map((item: any) => {
              return (
                // tslint:disable-next-line:jsx-key
                <div
                  className={
                    item.step <= step ? 'itemWrapper' : 'itemWrapper active'
                  }
                >
                  {item.label}
                </div>
              );
            })}
      </div>
      <div>
        <ul className={'stepper'}>
          {steps.map(({ key }, index) => (
            <li
              className={`stepperItem 
                                ${step >= index + 1 ? 'active' : ''} 
                                ${step === 2 ? 'activeLineFist' : ''} 
                                ${step === 3 ? 'activeLineFist activeLineLast' : ''}`}
              key={key}
              style={{
                ...{
                  width: `${
                    index === 0 || index === steps.length - 1
                      ? 100 / steps.length
                      : (100 / steps.length) * 2
                  }%`,
                },
              }}
            >
              <div className={`stepperWrapper`}>
                {step === index + 1 ? (
                  <IconWrapper>
                    <IconCircle kind="tick-points" isFilled={false} />
                  </IconWrapper>
                ) : step > index + 1 ? (
                  <IconWrapper>
                    <IconCircle kind="tick-points" isFilled={true} />
                  </IconWrapper>
                ) : (
                  <GreyDot />
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default RegisterStepper;
